import { SymbolType } from '@/containers/symbols/SymbolType'
import { SymbolsAnimationFactory } from './SymbolsAnimationFactory'
import { SymbolContainerData } from '@/modules'

export class LowValueSymbolsFactory extends SymbolsAnimationFactory {
    private static readonly LOW_LEVEL_BY_INDEX: Record<number, number> = {
        [SymbolType.LP_1]: 1,
        [SymbolType.LP_2]: 2,
        [SymbolType.LP_3]: 3,
        [SymbolType.LP_4]: 4,
        [SymbolType.LP_5]: 5,
    }

    public getAnimationResource(): string {
        return 'LV'
    }

    public getAnimationLabel(symbolData: SymbolContainerData, state: string): string {
        const lowLevel = LowValueSymbolsFactory.LOW_LEVEL_BY_INDEX[symbolData.index]
        if (!lowLevel) {
            return null
        }

        let label: string = null

        if (state === 'land' || state === 'landing') {
            label = `lv${lowLevel}_in`
        }

        if (!label && state === 'win') {
            label = `lv${lowLevel}_win`
        }

        if (!label && state === 'out') {
            label = `lv${lowLevel}_out`
        }

        if (label) {
            console.debug('[LV_ANIM_LABEL]', {
                symbolIndex: symbolData.index,
                lowLevel,
                state,
                label,
            })
            return label
        }

        return null
    }
}
